/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Requires_Local_MediaInputs */

const en_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please load a local media file to use offline sync.`)
};

const fr_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez charger un fichier média local pour utiliser la synchronisation hors ligne.`)
};

const de_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte laden Sie eine lokale Mediendatei, um die Offline-Synchronisierung zu verwenden.`)
};

const it_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica un file multimediale locale per usare la sincronizzazione offline.`)
};

const ru_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите локальный медиафайл, чтобы использовать оффлайн-синхронизацию.`)
};

const es_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga un archivo multimedia local para usar la sincronización sin conexión.`)
};

const zh_cn2_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请加载本地媒体文件以使用离线同步。`)
};

const ja_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン同期を使用するには、ローカルメディアファイルを読み込んでください。`)
};

const hi_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफलाइन सिंक उपयोग करने के लिए कृपया एक स्थानीय मीडिया फ़ाइल लोड करें।`)
};

const pt_pt2_offline_sync_requires_local_media = /** @type {(inputs: Offline_Sync_Requires_Local_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregue um ficheiro multimédia local para usar a sincronização offline.`)
};

/**
* | output |
* | --- |
* | "Please load a local media file to use offline sync." |
*
* @param {Offline_Sync_Requires_Local_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_requires_local_media = /** @type {((inputs?: Offline_Sync_Requires_Local_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Requires_Local_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_requires_local_media(inputs)
	if (locale === "de") return de_offline_sync_requires_local_media(inputs)
	if (locale === "it") return it_offline_sync_requires_local_media(inputs)
	if (locale === "ru") return ru_offline_sync_requires_local_media(inputs)
	if (locale === "es") return es_offline_sync_requires_local_media(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_requires_local_media(inputs)
	if (locale === "ja") return ja_offline_sync_requires_local_media(inputs)
	if (locale === "hi") return hi_offline_sync_requires_local_media(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_requires_local_media(inputs)
	return en_offline_sync_requires_local_media(inputs)
});